import React from 'react'

function AboutMePage(){
    return (
        <div>
            About Me Page
        </div>
    );
}

export default AboutMePage;